import React from 'react';
import { connect } from 'react-redux';
import { dateTimePickerFormat, LinkLikeButton } from '../../../../../util/util.jsx';
import {
  Col,
  Row,
  Glyphicon,
  Button,
} from 'react-bootstrap';
import {
  FormControl,
  DateTimePicker2 as DateTimePicker,
} from '../../../../form/FormControls.jsx';
import { List } from 'immutable';
import Label from '@/component/form/Label.jsx';
import RequiredFormControl from '../../../../form/RequiredFormControl.jsx';
import momentLocalizer from 'react-widgets-moment';
import { FormTextField } from '../../elements/FormTextField';
import moment from 'moment';
import { creationTimeTooltip } from '@/util/util';
moment.locale('en');
momentLocalizer();
import { usdDefaultCurrencyRates } from '@/util/util.jsx';
import CurrencyInput from '@/component/form/currencyinput/index.jsx';
import RefPicker from '../../../../dict/simple/select/DictPicker.jsx';
import UserPicker from '@/component/managment/users/Select.jsx';
import { containerLoadingStatus, vesselDischargingStatus } from '../../../../dict/Enums.js';
import ProductsViewer from '../ProductsViewer.jsx';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { updateDealField, updateDealFields, alterPortField } from '../../store/deal.store';
import { handleFormChanged } from '@/store/allaround.store.js';
import TransportElement from '../../elements/TransportElement.jsx';
import AbstractTransportEdit from '../AbstractTransportEdit';
import trash from '../../../../../../style/trash.png';
import loadport from '../../../../../../style/loadportblue.png';
import unloadport from '../../../../../../style/unloadportblue.png';

class ContainerEdit extends AbstractTransportEdit {
  constructor(props) {
    super(props);
    this.state = { transportNameVoyage: [], init: false };
    this.handleInsertButtonClick = this.handleInsertButtonClick.bind(this);
    this.renderModificationButtons = this.renderModificationButtons.bind(this);
    this.updateCell = this.updateCell.bind(this);
  }

  componentWillMount() {
    this.initNameVoyage(this.props, this.state);
  }
  componentWillReceiveProps(props) {
    this.initNameVoyage(props, this.state);
  }

  initNameVoyage(props, state) {
    if (props.transportNameVoyage && !state.init) {
      this.setState({ transportNameVoyage:
        this.createData(props.transportNameVoyage),
      init: true,
      });
    }
  }

  createData(transportNameVoyage) {
    if (!transportNameVoyage) {
      return transportNameVoyage;
    }
    const data = Array.isArray(transportNameVoyage) ?
      transportNameVoyage : transportNameVoyage.toJS();

    return data.map((elem, idx) =>
      ({ ...elem, idx })
    );
  }

  deleteVesselName(id) {
    const transportNameVoyage = this.state.transportNameVoyage;
    transportNameVoyage.splice(id, 1);
    this.setState({ transportNameVoyage: this.createData(transportNameVoyage) });
    this.props.updateDealField('transportNameVoyage', transportNameVoyage);
  }

  handleInsertButtonClick() {
    const transportNameVoyage = this.state.transportNameVoyage;
    transportNameVoyage.push({
      vesselName: '', voyageNumber: '', idx: transportNameVoyage.length });
    this.setState({ transportNameVoyage });
    this.props.updateDealField('transportNameVoyage', transportNameVoyage);
  }
  updateCell() {
    this.props.updateDealField('transportNameVoyage',
      this.state.transportNameVoyage);
  }
  renderModificationButtons = (id) =>
    <LinkLikeButton title="Delete" id={`delete_${id}`} onClick={() => this.deleteVesselName(id)}>
      <img className={'trash-icon'} src={trash} alt={'Delete'} title={'Delete'} />
    </LinkLikeButton>

  render() {
    return (
      <div>
        <input
          name="transportType" defaultValue="CONTAINER" style={{ display: 'none' }}
        />
        <Col md={12} className={'dealsEditTopPanel'}>
          <Row>
            <Col md={6}>
              <Row>
                <Col md={3}>
                  <Label
                    label="Creator" vertical sm={12}

                  >
                    {creationTimeTooltip(this.props.data, <UserPicker
                      name="creator"
                      defaultValue={this.props.isNew ? this.props.currentUser :
                        this.props.data.get('creator')}
                      disabled
                    />)}
                  </Label>

                </Col>
                <Col md={6}>
                  <Label
                    label="Chartering responsible"
                    vertical
                    sm={12}

                  >
                    <UserPicker
                      name="responsibles" multi
                      defaultValue={this.props.isNew ? this.props.currentUser
                        : this.props.data.get('responsibles')}
                      disabled={this.props.disabled || !this.props.allowResponsiblesEdit}
                    />
                  </Label>
                </Col>
                <Col md={3}>
                  <Label label="Forwarder" vertical sm={12} >
                    <RefPicker
                      dict="forwarder" name="forwarder"
                      defaultValue={this.props.data.get('forwarder')}
                      onChangeFunc={v => this.props.updateDealField('forwarder', v.value)}
                      disabled={this.props.disabled}
                    />
                  </Label>
                </Col>
              </Row>
            </Col>
            <Col md={2}>
              <Label label="Shipping line" vertical sm={12} >
                <RefPicker
                  dict="shippingline" name="shippingline"
                  defaultValue={this.props.data.get('shippingline')}
                  disabled={this.props.disabled}
                />
              </Label>
            </Col>
            <Col md={2}>
              <Label label="Freight" vertical sm={12} >
                <Row id="freightCurrency">
                  <Col sm={4}>
                    <CurrencyInput
                      name="freightCurrency"
                      defaultValue={this.props.data.get('freightCurrency')}
                      defaultValueRates={usdDefaultCurrencyRates(
                        this.props.data.get('freightCurrencyRates'))}
                      onChange={this.onChangeFreightCurrency}
                      disabled={this.props.disabled}
                    />
                  </Col>
                  <Col sm={8}>
                    {this.freightInput()}
                  </Col>
                </Row>
              </Label>
            </Col>
            <Col md={2} className="transport-buttons">
              <Button
                bsSize="xsmall"
                bsStyle={this.props.data.get('isArchived') ? 'primary' : 'gray'}

                id="isArchived"
                disabled={this.props.disabled || !(this.props.data.get('id')
                || this.props.data.get('id') == 0)}
                onClick={this.props.onArchive}
                title="Archive"
              >
                Archive
              </Button>

              <Button
                bsSize="xsmall"
                bsStyle={this.props.data.get('hasDispute') ? 'primary' : 'gray'}
                id="isArchived"
                disabled={this.props.disabled}
                onClick={() => {
                  this.props.updateDealField('hasDispute', !this.props.data.get('hasDispute'));
                  this.props.handleFormChanged();
                }}
                title="Dispute"
              >
                Dispute
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <BootstrapTable
                data={this.state.transportNameVoyage}
                cellEdit={this.props.disabled ?
                  {} : { mode: 'click', blurToSave: true, afterSaveCell: this.updateCell }}
                keyField=""
                className="transportVesselTable"
              >
                <TableHeaderColumn
                  width="50%" dataField="vesselName"
                >Vessel name</TableHeaderColumn>
                <TableHeaderColumn dataField="voyageNumber">Voyage number</TableHeaderColumn>
                <TableHeaderColumn
                  width="30"
                  dataFormat={this.props.disabled ? (() => {}) :
                    this.renderModificationButtons}
                  searchable={false}
                  dataField="idx"
                  isKey
                >
                  {this.props.disabled ?
                    ''
                    :
                    <LinkLikeButton
                      id="addVesselName" title="Add new" onClick={this.handleInsertButtonClick}
                    >
                      <Glyphicon glyph="plus" />
                    </LinkLikeButton>
                  }
                </TableHeaderColumn>
              </BootstrapTable>
            </Col>
            <Col md={6}>
              <Row>
                <Col md={6}>
                  <Label
                    label="Free demurrage" vertical sm={12}

                  >
                    <FormControl
                      name="freeDemurrage"
                      defaultValue={this.props.data.get('freeDemurrage')}
                      disabled={this.props.disabled}
                    />
                  </Label>
                </Col>
                <Col md={6}>
                  <Label
                    label="Free detention" vertical sm={12}

                  >
                    <FormControl
                      name="freeDetention"
                      defaultValue={this.props.data.get('freeDetention')}
                      disabled={this.props.disabled}
                    />
                  </Label>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Label label="Product" vertical sm={12} >
                    {this.props.data.get('links', new List()).size ?
                      <div>
                        <ProductsViewer links={this.props.data.get('links')} />
                        <input
                          name="product" value={this.props.product}
                          style={{ display: 'none' }}
                          onChange={() => ({})}
                        />
                      </div>
                      :
                      <RequiredFormControl
                        component={RefPicker}
                        noAddButton
                        dict="product"
                        dictType="complex"
                        name="linkedProducts"
                        onChangeFunc={val =>
                          this.props.updateDealField('linkedProducts', val.map(v => v.value))}
                        defaultValue={this.props.data.get('linkedProducts')}
                        multi
                        disabled={this.props.disabled}
                      />
                    }
                  </Label>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xs={12}>
          <Row >
            <Col xs={12} className={'transport-edit-total-bl-row'}>
              {this.renderBLInfo()}
            </Col>
            <Col xs={12}>
              <TransportElement data={this.props.data} editForm disabled={this.props.disabled} />
            </Col>
          </Row>
          <Row style={{ padding: '15px' }}>
            <Col md={6}>
              <Row
                className="transport-edit-port-block"
                style={{ marginRight: '-10px' }}
              >
                <Col sm={12}>
                  <Row>
                    <Col md={12}>
                      <img
                        src={loadport}
                        role={'presentation'} className={'small-transport-port-icon'}
                      />
                      <Label
                        label="Loading at" vertical sm={12}
                      >
                        <RefPicker
                          dict="port" name="loadingPort"
                          defaultValue={this.props.data.get('loadingPort')}
                          disabled={this.props.disabled}
                          onChangeFunc={val =>
                            this.props.alterPortField('loadingPort',
                              val !== undefined && val !== null ? val.value : val)}
                        />
                      </Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <Label label="Status" vertical sm={12} >
                        <FormControl
                          componentClass="select"
                          placeholder="Select..."
                          name="loadingPortStatus"
                          defaultValue={this.props.data.get('loadingPortStatus')}
                          disabled={this.props.disabled}
                        >
                          {containerLoadingStatus.entrySeq()
                            .map((vals) =>
                              <option key={vals[0]} value={vals[0]}>{vals[1]}</option>
                            )
                          }
                        </FormControl>
                      </Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Label
                        label="Cut off date" vertical sm={12}

                      >
                        <DateTimePicker
                          format={dateTimePickerFormat}
                          time={false}
                          name="cutOffDate"
                          onChange={(() => this.props.handleFormChanged())}
                          defaultValue={this.props.data.get('cutOffDate')
                            ? new Date(this.props.data.get('cutOffDate'))
                            : null}
                          disabled={this.props.disabled}
                        />
                      </Label>
                    </Col>
                    <Col md={6}>
                      <Label
                        label="On board date" vertical sm={12}

                      >
                        <DateTimePicker
                          format={dateTimePickerFormat}
                          time={false}
                          name="onBoardDate"
                          onChange={(() => this.props.handleFormChanged())}
                          defaultValue={this.props.data.get('onBoardDate')
                            ? new Date(this.props.data.get('onBoardDate'))
                            : null}
                          disabled={this.props.disabled}
                        />
                      </Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Label
                        label="Bill of lading date" vertical sm={12}

                      >
                        <DateTimePicker
                          format={dateTimePickerFormat}
                          time={false}
                          name="billLandingDate"
                          onChange={(() => this.props.handleFormChanged())}
                          defaultValue={this.props.data.get('billLandingDate')
                            ? new Date(this.props.data.get('billLandingDate'))
                            : null}
                          disabled={this.props.disabled}
                        />
                      </Label>
                    </Col>
                    <Col md={6}>
                      <Label
                        label="Sailing date" vertical sm={12}

                      >
                        <DateTimePicker
                          format={dateTimePickerFormat}
                          time={false}
                          name="loadingSailingDate"
                          onChange={(() => this.props.handleFormChanged())}
                          defaultValue={this.props.data.get('loadingSailingDate')
                            ? new Date(this.props.data.get('loadingSailingDate'))
                            : null}
                          disabled={this.props.disabled}
                        />
                      </Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <Label
                        label="Comment" vertical sm={12}
                      >
                        <FormTextField
                          name="loadingPortComment"
                          onChangeFunc={(val) =>
                            this.props.alterPortField('loadingPortComment', val)
                          }
                          defaultValue={this.props.data.get('loadingPortComment')}
                          disabled={this.props.disabled}
                        />
                      </Label>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row
                className="transport-edit-port-block"
                style={{ marginLeft: '-10px' }}
              >
                <Col sm={12}>
                  <Row>
                    <Col md={12}>
                      <img
                        src={unloadport}
                        role={'presentation'} className={'small-transport-port-icon'}
                      />
                      <Label
                        label="Discharge at" vertical sm={12}

                      >
                        <RefPicker
                          dict="port" name="dischargePort"
                          defaultValue={this.props.data.get('dischargePort')}
                          disabled={this.props.disabled}
                          onChangeFunc={val =>
                            this.props.alterPortField('dischargePort',
                              val !== undefined && val !== null ? val.value : val)}
                        />
                      </Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <Label label="Status" vertical sm={12} >
                        <FormControl
                          componentClass="select"
                          placeholder="Select..."
                          name="dischargePortStatus"
                          defaultValue={this.props.data.get('dischargePortStatus')}
                          disabled={this.props.disabled}
                        >
                          {vesselDischargingStatus.entrySeq()
                            .map((vals) =>
                              <option key={vals[0]} value={vals[0]}>{vals[1]}</option>
                            )
                          }
                        </FormControl>
                      </Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Label
                        label="ETA Discharge port" vertical sm={12}

                      >
                        <DateTimePicker
                          format={dateTimePickerFormat}
                          time={false}
                          name="etaDischarge"
                          onChange={(() => this.props.handleFormChanged())}
                          defaultValue={this.props.data.get('etaDischarge')
                            ? new Date(this.props.data.get('etaDischarge'))
                            : null}
                          disabled={this.props.disabled}
                        />
                      </Label>
                    </Col>
                    <Col md={6}>
                      <Label
                        label="Discharge date" vertical sm={12}

                      >
                        <DateTimePicker
                          format={dateTimePickerFormat}
                          time={false}
                          name="dischargeDate"
                          onChange={(() => this.props.handleFormChanged())}
                          defaultValue={this.props.data.get('dischargeDate')
                            ? new Date(this.props.data.get('dischargeDate'))
                            : null}
                          disabled={this.props.disabled}
                        />
                      </Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Label
                        label="Sailing date" vertical sm={12}
                      >
                        <DateTimePicker
                          format={dateTimePickerFormat}
                          time={false}
                          name="dischargeSailingDate"
                          onChange={(() => this.props.handleFormChanged())}
                          defaultValue={this.props.data.get('dischargeSailingDate')
                            ? new Date(this.props.data.get('dischargeSailingDate'))
                            : null}
                          disabled={this.props.disabled}
                        />
                      </Label>
                    </Col>
                    <Col md={6} />
                  </Row>
                  <Row>
                    <Col md={12}>
                      <Label
                        label="Comment" vertical sm={12}
                      >
                        <FormTextField
                          name="dischargePortComment"
                          onChangeFunc={(val) =>
                            this.props.alterPortField('dischargePortComment', val)
                          }
                          defaultValue={this.props.data.get('dischargePortComment')}
                          disabled={this.props.disabled}
                        />
                      </Label>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </div>
    );
  }
}
ContainerEdit.propTypes = {
  data: React.PropTypes.object,
  disabled: React.PropTypes.bool,
  openModal: React.PropTypes.func,
  hidden: React.PropTypes.bool,
  cancel: React.PropTypes.func,
  onFromSubmitHandler: React.PropTypes.func,
  product: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
  updateProduct: React.PropTypes.func,
  updateDealField: React.PropTypes.func,
  updateDealFields: React.PropTypes.func,
  transportNameVoyage: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.array]),
  currentUser: React.PropTypes.number,
  isNew: React.PropTypes.bool,
  alterPortField: React.PropTypes.func,
  onArchive: React.PropTypes.func,
};

export default connect(
  (state) => ({
    transportNameVoyage:
      state.getIn(['data', 'deals', 'deal', 'transportNameVoyage']),
    currentUser: Number(state.getIn(['session', 'id'])),
  }),
  dispatch => ({
    updateDealField(field, value, idx) {
      updateDealField(dispatch, 'transport', field, value, idx);
    },
    updateDealFields(map) {
      updateDealFields(dispatch, map);
    },
    alterPortField(portType, id) {
      alterPortField(dispatch, portType, id);
    },
    handleFormChanged() {
      handleFormChanged(dispatch);
    },
  })

)(ContainerEdit);
